"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/SegmentedControl.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);















// A tab list styled as a pill toggle (Provider | Patient). Arrow keys move
// between the tabs, as the ARIA tabs pattern expects.
function SegmentedControl ({
  label, segments, value, onChange, idPrefix,
}) {
  const tabRefs = _react.useRef([])

  const onKeyDown = (e, index) => {
    const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0
    if (!step) return
    e.preventDefault()
    const next = (index + step + segments.length) % segments.length
    const segment = segments[next]
    if (!segment) return
    onChange(segment.value)
    _optionalChain([tabRefs, 'access', _ => _.current, 'access', _2 => _2[next], 'optionalAccess', _3 => _3.focus, 'call', _4 => _4()])
  }

  return (
    _react2.default.createElement('div', { className: "auth-seg", role: "tablist", 'aria-label': label, __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
      ,  segments.map((s, i) => {
        const isSelected = s.value === value
        return (
          _react2.default.createElement('button', {
            key: s.value,
            ref: el => { tabRefs.current[i] = el },
            type: "button",
            role: "tab",
            id: `${idPrefix}-tab-${s.value}`,
            'aria-selected': isSelected,
            'aria-controls': `${idPrefix}-panel-${s.value}`,
            tabIndex: isSelected ? 0 : -1,
            className: _classBuilder2.default.call(void 0, 'auth-seg--item', isSelected && 'auth-seg--item--on'),
            onClick: () => onChange(s.value),
            onKeyDown: e => onKeyDown(e, i), __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}

            ,  s.label 
          )
        )
      })
    )
  )
}

exports. default = SegmentedControl
